import { Directive, Input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from "@angular/forms";

@Directive({
    selector: '[appNumberValidator]',
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: NumberValidatorDirective,
        multi: true
    }]
})
export class NumberValidatorDirective implements Validator {
        
    validate(control: AbstractControl) : {[key: string]: any} | null {
        if (!this.numberValidator(control.value)) {
            return { 'numberInvalid': true };
        }
        return null;
    }

    numberValidator(number: string){       
        return new RegExp(/^[0-9]*$/).test(number);
    }
}